import { Component, EventEmitter, Inject, Input, OnInit, Output, ViewChild } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";

import { SharedService } from "@shared/services/shared.service";
import { IBusiness, IBusinessView, INotesViewModel } from "app/models/business/business";
import { IComplaint } from "app/models/complaints/complaints";
import { IAdministrativeComplaintView } from "app/models/mainMenu/mainMenu";
import { BusinessService } from "app/services/business/business.service";
import { ComplaintService } from "app/services/complaint/complaint.service";
import { Subscription } from "rxjs";


@Component({
  selector: 'business-businessComplaintList',
  templateUrl: './businessComplaintList.component.html',
  styleUrls: ['./businessComplaintList.component.scss']
})

export class BusinessComplaintListComponent implements OnInit {

  @Input() businessId: number = 0;

  @Output() closeEvent = new EventEmitter<string>();

  businessSubscription: Subscription;
  currentBusiness: IBusinessView = {} as IBusinessView;
  complaintsList: IAdministrativeComplaintView[] = [];
  complaintCount: number = 0;
  commentCount: number = 0;
  currentTab: number = 0;
  editBusinessFlag: boolean = false;

  displayedColumns: string[] = ['complaintId', 'complaintDate', 'complaintStatus', 'actionable', 'complaintComments'];
  dataSource = new MatTableDataSource<IAdministrativeComplaintView>(this.complaintsList);

  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort') sort: MatSort;

  constructor(
    private sharedService: SharedService,
    private businessService: BusinessService,
    private complaintService: ComplaintService,

  ) {

  }

  ngOnInit(): void {

    this.businessSubscription = this.businessService.updateBusinessEvent.subscribe((data: number) => {
      if (data == 0) {
        let list = this.businessService.currentBusiness ? this.businessService.currentBusiness.complaints : [];
        this.dataSource.data = list;
      }
    });
    this.dataSource.data = this.businessService.currentBusiness ? this.businessService.currentBusiness.complaints : [];
    this.businessId = this.businessService.businessId;
  }

  ngOnDestroy() {
    this.businessSubscription.unsubscribe();
  }

  gotoComplaint(complaintId: string) {
    this.complaintService.complaintId = +complaintId;
    this.complaintService.complaintTab = 0;
    this.sharedService.doRedirect('complaint/complaint/'+complaintId);
    this.closeEvent.emit('close');
  }

}